import React from 'react';

import { EventType } from 'types/event.types';
import { Sheet, SheetContent } from '@epoch-ui/components/Sheet/sheet';

import { useEditableEvent } from '../../hooks/useEditableEvent';
import { useEditEventDetailsSheet } from '../../hooks/eventEditorState';

import { EditSingleEventBasicDetailsForm } from './EditSingleEventBasicDetailsForm';
import { EditMultiSessionEventBasicDetailsForm } from './EditMultiSessionEventBasicDetailsForm';

export const EditEventDetailsSheet = (): React.ReactElement => {
  const event = useEditableEvent();
  const editEventDetailsSheetState = useEditEventDetailsSheet();

  return (
    <Sheet
      open={editEventDetailsSheetState.isOpen}
      onOpenChange={(open) => {
        if (open) {
          editEventDetailsSheetState.open();
        } else {
          editEventDetailsSheetState.close();
        }
      }}
    >
      <SheetContent
        className="tw-m-2 tw-flex tw-h-[calc(100vh-16px)] tw-w-[480px] tw-flex-col tw-gap-0 tw-rounded-3xl tw-p-0 sm:tw-max-w-[480px]"
        aria-describedby=""
      >
        {event.eventType === EventType.SINGLE && <EditSingleEventBasicDetailsForm />}
        {event.eventType === EventType.MULTI_SESSIONS && <EditMultiSessionEventBasicDetailsForm />}
      </SheetContent>
    </Sheet>
  );
};
